// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import type { TopSelectionProps } from "@dip/helsecore/src/components/parts/TopSelection/TopSelection.d";
import { TopSelection } from "@dip/helsecore/src/components/parts/TopSelection/TopSelection";

export default (props: Readonly<TopSelectionProps>) => <TopSelection {...props} />
